import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { themeLight } from './theme.light';
import { themeDark } from './theme.dark';
/**
 * Turns the theme maps into CSS custom property declarations.
 *
 * `semantic.ts` emits `var(--tf-<key>)` references and `TFButton.less` writes the same
 * references literally — LESS passes `var()` through untouched, so the two sides are
 * joined by NAME in the browser, not by the build. The contract is the `--tf-` prefix,
 * nothing more.
 *
 * Deleted at migration: v9's `FluentProvider` emits its own custom properties.
 */ export var TOKEN_PREFIX = '--tf-';
/** The app's existing dark-mode class — `AppInner.tsx` puts it on `#containerin`. */ var DARK_SELECTOR = '.dark';
var STYLE_ELEMENT_ID = 'tf-design-tokens';
var declarations = function declarations(theme) {
    return Object.entries(theme).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(TOKEN_PREFIX).concat(key, ":").concat(value);
    }).join(';');
};
/**
 * ONE stylesheet with both blocks, dark second. `:root` and `.dark` are both
 * specificity 0-1-0, so source order is what makes dark win — splitting them
 * across two stylesheets would hand that to non-deterministic chunk order.
 */ export var tokenStyleSheet = function tokenStyleSheet() {
    return ":root{".concat(declarations(themeLight), "}").concat(DARK_SELECTOR, "{").concat(declarations(themeDark), "}");
};
/** Idempotent — HMR re-runs this and must not stack `<style>` tags. */ export var injectTokens = function injectTokens() {
    if (typeof document === 'undefined' || document.getElementById(STYLE_ELEMENT_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ELEMENT_ID;
    style.textContent = tokenStyleSheet();
    document.head.appendChild(style);
};
